
import { specification, uiLang } from './store';

export function baseUrl(name) {
    const specification = getSpecification();
    const uiLang = getLangCode();

    const slug = (uiLang === 'ga') ? 'scribhneoiri' : 'writers';
    let path = `/${uiLang}/${slug}/`;
    let params = [];

    if (!!specification.abc) path += `${specification.abc}/`;
    if (!!specification.media && name !== 'media') path += `${(uiLang === 'ga') ? 'fuaim' : 'audio'}/`;

    if (!!specification.birthDate && name !== 'birthDate') params.push({ "birthDate": specification.birthDate });
    if (!!specification.gender && name !== 'gender') params.push({ "gender": specification.gender });
    if (!!specification.genre && name !== 'genre') params.push({ "genre": specification.genre });
    if (!!specification.photographer && name !== 'photographer') params.push({ "photographer": specification.photographer });

    path += getQueryString(params);
    return path;
}

export function optionUrl(name, id) {
    const specification = getSpecification();
    const uiLang = getLangCode();

    const slug = (uiLang === 'ga') ? 'scribhneoiri' : 'writers';
    let path = `/${uiLang}/${slug}/`;
    let params = [];

    if (!!specification.abc) path += `${specification.abc}/`;
    if (!!specification.media || name === 'media' && id === 'audio') path += `${(uiLang === 'ga') ? 'fuaim' : 'audio'}/`;

    if (!!specification.birthDate) params.push({ "birthDate": specification.birthDate });
    if (!!specification.gender) params.push({ "gender": specification.gender });
    if (!!specification.genre) params.push({ "genre": specification.genre });
    if (!!specification.photographer) params.push({ "photographer": specification.photographer });

    if (name === 'birthDate') {
        if (params.length > 0 && params.find(x => x.birthDate)) {
            params[params.findIndex(x => x.birthDate)] = { "birthDate": id };
        } else {
            params.push({ "birthDate": id });
        }
    }

    if (name === 'gender') {
        if (params.length > 0 && params.find(x => x.gender)) {
            params[params.findIndex(x => x.gender)] = { "gender": id };
        } else {
            params.push({ "gender": id });
        }
    }

    if (name === 'genre') {
        if (params.length > 0 && params.find(x => x.genre)) {
            params[params.findIndex(x => x.genre)] = { "genre": id };
        } else {
            params.push({ "genre": id });
        }
    }

    if (name === 'photographer') {
        if (params.length > 0 && params.find(x => x.photographer)) {
            params[params.findIndex(x => x.photographer)] = { "photographer": id };
        } else {
            params.push({ "photographer": id });
        }
    }

    path += getQueryString(params);
    return path;
}

function getLangCode() {
    let langCode;

    const unsubscribe = uiLang.subscribe(value => {
        langCode = value;
    });

    unsubscribe();

    return langCode;
}

function getSpecification() {
    let spec;

    const unsubscribe = specification.subscribe(value => {
        spec = value;
    });

    unsubscribe();

    return spec;
}

function getQueryString(params) {
    let queryString = "";

    if (!params || params.length === 0)
        return queryString;
    
    queryString += '?';
    queryString += params.map(x => {
        const key = Object.keys(x)[0];
        return `${key}=${x[key]}`;
    })
    .join('&');

    return queryString;
}